import { RefreshRegistrationOptions, RefreshTableOptions } from '@/hooks/registration/useRegistrationLifecycle';
import { createContext, useContext } from 'react';

type RegistrationLifecycleContextValue = {
    formatUtcToStoreTime: (value?: string | null) => string;
    refreshTable: (options?: RefreshTableOptions) => Promise<void>;
    refreshRegistrationNow: (options?: RefreshRegistrationOptions) => Promise<boolean>;
};

export const RegistrationLifecycleContext = createContext<RegistrationLifecycleContextValue | null>(null);

export const useRegistrationLifecycleState = () => {
    const context = useContext(RegistrationLifecycleContext);

    if (!context) {
        throw new Error('useRegistrationLifecycleState must be used within RegistrationLifecycleProvider');
    }

    return context;
};
